module.exports = __webpack_public_path__ + "static/media/OR.4647e355.svg";